import { computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleDefaultCover } from '@rebuild/hooks/comp/useModuleDefaultCover';

export const useSurfNews = () => {
	const { news } = useModuleData();
	const { viewModule } = useModuleNavigation();
	const { getDefaultCover } = useModuleDefaultCover();

	// 数据
	const newsData = computed(() => {
		const data = news.data?.data || [];
		return data;
	});

	// 加载数据
	const loadNewsData = async (params = {}) => {
		await news.refresh({
			pageStart: params.pageStart,
			pageNum: params.pageNum
		});
	};

	const formatForOverview = item => {
		return {
			image: item.image || getDefaultCover('surf_news'),
			value: item.title || '',
			date: item.time || ''
		};
	};

	// 预览详情
	const handlePreview = item => {
		viewModule('news', item);
	};

	// 是否为空
	const isEmpty = computed(() => {
		return news.empty || !newsData.value.length;
	});

	return {
		news,
		newsData,
		loadNewsData,
		formatForOverview,
		handlePreview,
		isEmpty
	};
};
